import { FadeUp, RevealMaskScroll } from "../components/Reveal";
import { useSiteContent } from "../context/SiteContentContext";

const Q = "?auto=compress&cs=tinysrgb&w=1200";
const IMG = {
  bride2: "https://images.pexels.com/photos/28405815/pexels-photo-28405815.jpeg" + Q,
  saree1: "https://images.pexels.com/photos/2723623/pexels-photo-2723623.jpeg" + Q,
  saree_red: "https://images.pexels.com/photos/36951188/pexels-photo-36951188.jpeg" + Q,
  jewel1: "https://images.pexels.com/photos/25399495/pexels-photo-25399495.jpeg" + Q,
};

const POSTS = [
  { title: "The Art of the Banarasi Weave", excerpt: "Inside the looms of Varanasi, where a single saree can take forty days to complete.", img: IMG.saree_red, cat: "Craft", date: "Nov 2025" },
  { title: "How to Style Ivory for a Wedding", excerpt: "The new bridal neutral, and five ways to make it entirely your own.", img: IMG.bride2, cat: "Styling", date: "Oct 2025" },
  { title: "Zardozi: A Thread of Gold", excerpt: "The centuries-old embroidery technique that defines our couture line.", img: IMG.jewel1, cat: "Heritage", date: "Oct 2025" },
  { title: "Behind the Autumn Campaign", excerpt: "A day on set with our muses, captured in the golden hour of Amraiya.", img: IMG.saree1, cat: "Atelier", date: "Sep 2025" },
];

export default function Journal() {
  const [feature, ...rest] = POSTS;
  const site = useSiteContent();
  const t = (k, f) => site.text(k, f);

  return (
    <div className="pt-20" data-testid="journal-page">
      <div className="px-5 md:px-10 pt-16 pb-12 max-w-[1600px] mx-auto">
        <FadeUp><p className="overline text-gold-deep mb-4">{t("journal_kicker", "The Journal")}</p></FadeUp>
        <h1 className="font-serif text-6xl md:text-8xl tracking-tight leading-none">
          <RevealMaskScroll>{t("journal_title", "Stories & craft")}</RevealMaskScroll>
        </h1>
      </div>

      <div className="px-5 md:px-10 max-w-[1600px] mx-auto pb-28">
        <FadeUp>
          <div className="group grid md:grid-cols-2 gap-8 items-center mb-20">
            <div className="relative aspect-[4/3] overflow-hidden order-2 md:order-1">
              <img src={feature.img} alt={feature.title} className="h-full w-full object-cover transition-transform duration-[1.2s] group-hover:scale-105" />
            </div>
            <div className="order-1 md:order-2">
              <p className="overline text-gold-deep mb-4">{feature.cat} · {feature.date}</p>
              <h2 className="font-serif text-4xl md:text-6xl tracking-tight leading-none mb-5">{feature.title}</h2>
              <p className="text-ink-soft leading-relaxed max-w-md">{feature.excerpt}</p>
              <span className="mt-6 inline-block overline link-underline">Read the story</span>
            </div>
          </div>
        </FadeUp>

        <div className="grid md:grid-cols-3 gap-8">
          {rest.map((p, i) => (
            <FadeUp key={i} delay={i * 0.08}>
              <div className="group cursor-pointer">
                <div className="aspect-[4/5] overflow-hidden mb-5">
                  <img src={p.img} alt={p.title} className="h-full w-full object-cover transition-transform duration-[1.2s] group-hover:scale-105" />
                </div>
                <p className="overline text-gold-deep mb-2">{p.cat} · {p.date}</p>
                <h3 className="font-serif text-2xl tracking-tight leading-tight group-hover:text-gold-deep transition-colors">{p.title}</h3>
                <p className="text-sm text-ink-soft mt-2 leading-relaxed">{p.excerpt}</p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </div>
  );
}
